import { deleteLedgerBalanceMonitor } from "src/api/merchant";
import DeleteDialogProvider, {
  useDialogProviderContext,
} from "src/features/DialogProvider";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useAlerting, useTranslation } from "src/hooks";
import { GetListRes } from "src/views/Ledger/LedgerBalanceMonitor/types/GetListRes";
import {
  TableColumnKey,
  TableRow,
} from "src/views/Ledger/LedgerBalanceMonitor/types/Table";

function DeleteDialog({
  rowData,
}: {
  rowData: TableRow & { rawData: GetListRes };
}) {
  const { translatePrefix, refreshData } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);

  const { setIsOpen } = useDialogProviderContext();

  const { alerting } = useAlerting();

  const onConfirm = async () => {
    const res = await deleteLedgerBalanceMonitor({
      assetName: rowData[TableColumnKey.Currency],
      clientId: rowData[TableColumnKey.ClientId],
      chainType: rowData.rawData.chain_type,
      chainId: rowData.rawData.chain_id,
    });

    if (!res) {
      return;
    }

    alerting("success", t("delete_ledger_balance_monitor_success"));
    refreshData();
    setIsOpen(false);
  };

  return (
    <DeleteDialogProvider.DialogInOne
      title={t("delete_dialog_title")}
      content={null}
      onConfirm={onConfirm}
    />
  );
}

export default DeleteDialog;
